import { combineReducers } from '@reduxjs/toolkit';
import previewReducer from './slices/game/previewSlice';
import permissionSlice from './slices/access/permissionSlice';
import sseReducer from './slices/sse/sseSlice';

const rootReducer = combineReducers({
  preview: previewReducer,
  userPrivileges: permissionSlice,
  sse: sseReducer,
});

export default rootReducer;
